import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";
import select from "./modules/select";
import tree from "./modules/tree";
import actions from "./modules/actions";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    select,
    tree,
    actions,
  },
  getters,
});

export default store;
